import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "@phosphor-icons/react";
import Reveal from "@/components/Reveal";
import { NEARBY } from "@/lib/site";

export default function NearbySection() {
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32" data-testid="nearby-section">
      <Reveal className="max-w-2xl mb-16">
        <div className="overline">Things to do in Ballarat</div>
        <h2 className="font-serif text-4xl sm:text-5xl tracking-tight leading-tight mt-4">
          Hike Sovereign Hill <em className="italic font-light">— and the rest of Ballarat — from your front door.</em>
        </h2>
        <p className="mt-6 text-sa-ink2 text-base sm:text-lg leading-relaxed">
          Stay at our Ballarat caravan park and you're a short walk or drive from regional Victoria's best hiking, family attractions and lakeside trails.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {NEARBY.map((n, i) => (
          <Reveal key={n.title} delay={i * 80}>
            <article className="group flex flex-col gap-5 h-full" data-testid={`nearby-${i}`}>
              <div className="overflow-hidden rounded-2xl aspect-[4/3] bg-sa-bg2 relative">
                <span className="absolute top-4 left-4 z-10 bg-sa-bg/90 text-sa-ink text-[10px] tracking-[0.22em] uppercase px-3 py-1.5 rounded-full">
                  {n.tag}
                </span>
                <img
                  src={n.image}
                  alt={n.alt || n.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                />
              </div>
              <div className="flex items-center gap-2 text-xs text-sa-ink2">
                <MapPin size={14} weight="duotone" className="text-sa-accent" /> {n.distance}
              </div>
              <h3 className="font-serif text-2xl tracking-tight">{n.title}</h3>
              <p className="text-sa-ink2 text-[15px] leading-relaxed">{n.blurb}</p>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-16 flex items-center gap-3 text-sa-ink2">
        <span className="text-sm">Plan your trip:</span>
        <Link to="/accommodation" className="text-sa-accent hover:text-sa-accentHover inline-flex items-center gap-1 text-sm" data-testid="nearby-acc-link">
          accommodation in Ballarat <ArrowRight size={14} weight="bold" />
        </Link>
        <span className="text-sa-ink2/40">·</span>
        <Link to="/amenities" className="text-sa-accent hover:text-sa-accentHover inline-flex items-center gap-1 text-sm" data-testid="nearby-amen-link">
          park amenities <ArrowRight size={14} weight="bold" />
        </Link>
      </Reveal>
    </section>
  );
}
